import { useEffect, useState } from "react";
import s from "../styles";
import moment from "moment";
import ls from "components/common/ListWithMoreOptions/ItemRow/styles";
import { useTranslation } from "react-i18next";
import ClockInRowForm from "./ClockInRowForm";

const ClockInRowMap = ({ item, actions, updateEnabled }) => {
  const { t } = useTranslation();
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (!updateEnabled && updating) setUpdating(false);
  }, [updateEnabled, updating]);

  if (updating) {
    return (
      <ClockInRowForm actions={actions} item={item} setUpdating={setUpdating} />
    );
  }

  return [
    <ls.TableCell key="clockInRowDateTime">
      {moment(item.clockDatetime).format("YYYY-MM-DD hh:mm A")}
    </ls.TableCell>,
    <ls.TableCell key="clockInRowAction">{actions[item.type]}</ls.TableCell>,
    <ls.TableCell key="clockInRowNotes">{item?.notes || "-"}</ls.TableCell>,
    updateEnabled && (
      <ls.TableCell key="clockInRowActionButtons">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
            width: "100%",
            marginRight: "20px",
          }}
        >
          <s.button
            type={"text"}
            onClick={() => {
              setUpdating(true);
            }}
          >
            {t("actions.edit")}
          </s.button>
        </div>
      </ls.TableCell>
    ),
  ];
};

export default ClockInRowMap;
